import api from '@/lib/api'
import type { JobConnector, JobResume } from '@/lib/jobs'
import { normalizeAgentOperationStatusPath, shouldTerminateAgentOperationPolling } from '@/lib/agentOperationPath'

/** Agent üzerinde kalıcı çalışan işi tarayıcı yenilense bile aynı durum yolundan izler. */
export function createAgentOperationConnector(statusPath: string, resume: JobResume, onFinish?: (ok: boolean) => void): JobConnector {
  const normalizedStatusPath = normalizeAgentOperationStatusPath(statusPath)
  return handlers => {
    let stopped = false
    let polling = false
    let cursor = Number(resume.cursor || 0)
    let timer: number | null = null
    let failures = 0
    async function poll() {
      if (stopped || polling) return
      polling = true
      try {
        const response = await api.get(normalizedStatusPath)
        failures = 0
        const output = String(response.data?.output || '')
        if (output.length < cursor) cursor = 0
        if (output.length > cursor) handlers.appendLine(output.slice(cursor))
        cursor = output.length
        handlers.setResume({ ...resume, kind: 'agent-operation', statusPath: normalizedStatusPath, cursor })
        const state = String(response.data?.status || '')
        if (state !== 'running') {
          if (timer !== null) window.clearInterval(timer)
          timer = null
          const ok = state === 'success' || response.data?.success === true
          handlers.finish(ok)
          onFinish?.(ok)
        }
      } catch (error: any) {
        if (document.visibilityState !== 'visible') return
        failures += 1
        // İş oluşturma yanıtı ile state'in görünür olması arasında eski/yavaş
        // agent'larda kısa bir pencere olabilir. Tek 404 kalıcı işi bitirmez.
        if (shouldTerminateAgentOperationPolling(error?.response?.status, failures)) {
          const detail = String(error?.response?.data?.detail || error?.message || error)
          handlers.appendLine(`\nKalıcı iş durumu alınamadı: ${detail === 'package job not found' ? 'Bakım işi kaydı bulunamadı. İş başlamadıysa güvenle yeniden deneyebilirsiniz.' : detail}`)
          if (timer !== null) window.clearInterval(timer)
          handlers.finish(false)
        }
      } finally { polling = false }
    }
    void poll()
    timer = window.setInterval(poll, 1500)
    return { cleanup: () => { stopped = true; if (timer !== null) window.clearInterval(timer) } }
  }
}
